import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import {
  HomeIcon,
  PlusIcon,
  ChatIcon,
  SparklesIconFilled,
  UserIconFilled,
} from "./icons/FeatherIcons";
import {
  useActivityChatData,
  useActivityNotificationsData,
} from "../contexts/ActivityContext";
import { useAuth } from "../contexts/AuthContext";
import logoImage from "../src/assets/1024.png";
import { Capacitor } from "@capacitor/core";

const BottomNavigation: React.FC = () => {
  const { currentUser } = useAuth();
  const { getUnreadMessageCount } = useActivityChatData();
  const { getUnreadNotificationCount } = useActivityNotificationsData();
  const unreadMessages = currentUser
    ? getUnreadMessageCount(currentUser.id)
    : 0;
  const unreadNotifications = currentUser
    ? getUnreadNotificationCount(currentUser.id)
    : 0;

  const navLinkClasses = ({ isActive }: { isActive: boolean }) =>
    `flex flex-col items-center justify-center w-full text-xs transition-colors duration-200 ${
      isActive ? "text-primary" : "text-gray-500 hover:text-primary"
    }`;

  return (
    <footer
      className="fixed bottom-0 left-0 right-0 bg-white backdrop-blur-lg border-t border-gray-200 z-50 pb-safe"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <nav className="flex justify-around items-center h-16">
        <NavLink
          to="/"
          end
          className={({ isActive }) =>
            `relative ${navLinkClasses({ isActive })}`
          }
        >
          <HomeIcon className="w-7 h-7 mb-1" />
          <span className="font-semibold">Home</span>
          {unreadNotifications > 0 && (
            <span className="absolute top-0 right-[calc(50%-20px)] w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-white"></span>
          )}
        </NavLink>

        <NavLink to="/foryou" end className={navLinkClasses}>
          <SparklesIconFilled className="w-7 h-7 mb-1" />
          <span className="font-semibold">For You</span>
        </NavLink>

        <NavLink
          to="/create"
          className="flex items-center justify-center -mt-8 group"
          aria-label="Create Activity"
        >
          <div className="bg-gradient-to-br from-primary to-brand-purple-deep rounded-full w-16 h-16 flex items-center justify-center shadow-glow-primary transform group-hover:scale-110 transition-transform duration-300 ease-in-out overflow-hidden">
            <img
              src={logoImage}
              alt="Create Activity"
              className="w-12 h-12 object-cover rounded-full"
              onError={(e) => {
                e.currentTarget.style.display = "none";
                const fallback = e.currentTarget.parentElement?.querySelector(
                  ".fallback-icon",
                ) as HTMLElement;
                if (fallback) fallback.style.display = "block";
              }}
            />
            <PlusIcon
              className="w-9 h-9 fallback-icon text-white"
              strokeWidth={2.5}
              style={{ display: "none" }}
            />
          </div>
        </NavLink>

        <NavLink
          to="/chat"
          className={({ isActive }) =>
            `relative ${navLinkClasses({ isActive })}`
          }
        >
          <ChatIcon className="w-7 h-7 mb-1" />
          <span className="font-semibold">Chat</span>
          {unreadMessages > 0 && (
            <span className="absolute top-0 right-[calc(50%-26px)] w-5 h-5 bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center border-2 border-white">
              {unreadMessages}
            </span>
          )}
        </NavLink>

        <NavLink to="/profile" end className={navLinkClasses}>
          <UserIconFilled className="w-7 h-7 mb-1" />
          <span className="font-semibold">Profile</span>
        </NavLink>
      </nav>
    </footer>
  );
};

export default BottomNavigation;
